import { getCurrentTimezone } from 'src/react/_util/dates/timezone';
import { CreateInitialParamsData } from '../_flows/createInitialParams';

export const getPostInitialParamsApiData = ({ data }: { data: CreateInitialParamsData }) => {
  const {
    company: { defaultCountry, key: companyKey },
    employee,
    job,
    insured,
    origin,
    destination,
  } = data;

  const jobWithAppendedFields = {
    ...job,
    companyKey,
    employeeKey: employee ? employee.key : null,
    timezone: getCurrentTimezone(),
  }; // the API requires these fields to be included with the job object

  return {
    insured,
    origin,
    destination,
    companyKey,
    defaultCountry,
    job: jobWithAppendedFields,
  };
};
